import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface SubmitFooterAiInsightsButtonProps {
  enableAiInsights: boolean;
  aiWarningsCount: number;
  onOpenAiInsights: () => void;
}

/** Opens the AI Insights sheet; only rendered when there are warnings to show. */
export function SubmitFooterAiInsightsButton({
  enableAiInsights,
  aiWarningsCount,
  onOpenAiInsights,
}: SubmitFooterAiInsightsButtonProps) {
  if (!enableAiInsights || aiWarningsCount === 0) return null;

  return (
    <Button
      variant="outline"
      size="default"
      onClick={onOpenAiInsights}
      className="flex-1 sm:flex-none gap-2"
    >
      <Sparkles className="h-4 w-4" />
      <span>Insights</span>
    </Button>
  );
}
